import * as z from "zod";
import { gql } from "graphql-request";

import { Sys, SysFragment } from "./sys";
import { Targeting, TargetingFragment } from "./targeting";
import { RelatedMedia, RelatedMediaFragment } from "./relatedMedia";
import {
  LocalizedHero,
  LocalizedHeroFragment,
} from "./newsEntryTypes/localizedHero";
import {
  CarouselEventProgressTrackerEntry,
  CarouselEventProgressTrackerEntryFragment,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";

export const Hero = z.object({
  __typename: z.literal("Hero"),
  sys: Sys,
  targeting: Targeting.nullable(),
  relatedMedia: RelatedMedia.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      LocalizedHero,
      CarouselEventProgressTrackerEntry,
    ])
    .nullish(),
});

export type Hero = z.infer<typeof Hero>;

export const HeroFragment = gql`
  fragment HeroFragment on Hero {
    __typename
    sys {
      ...SysFragment
    }
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    localized {
      ... on LocalizedHero {
        ...LocalizedHeroFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }
  ${SysFragment}
  ${LocalizedHeroFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
  ${CarouselEventProgressTrackerEntryFragment}
`;
